import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { InventoryReportFilterModel } from 'src/app/models/inventory/inventory-report-filter.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InventoryReportService {

  constructor(private _httpClient: HttpClient) { }

  exportInventoryReportBranchAverageCost(inventoryReportFilterModel: InventoryReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.ExportInventoryReportBranchAverageCost}`, inventoryReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportInventoryReportEntryShop(inventoryReportFilterModel: InventoryReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.ExportInventoryReportEntryShop}`, inventoryReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportInventoryReportKardexArticle(inventoryReportFilterModel: InventoryReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.ExportInventoryReportKardexArticle}`, inventoryReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportInventoryReportOutputShop(inventoryReportFilterModel: InventoryReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.ExportInventoryReportOutputShop}`, inventoryReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportInventoryReportStockMax(inventoryReportFilterModel: InventoryReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.ExportInventoryReportStockMax}`, inventoryReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportInventoryReportStockMin(inventoryReportFilterModel: InventoryReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.ExportInventoryReportStockMin}`, inventoryReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportInventoryReportSummaryInventoryMovement(inventoryReportFilterModel: InventoryReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.ExportInventoryReportSummaryInventoryMovement}`, inventoryReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportInventoryReportTypeDetailedValues(inventoryReportFilterModel: InventoryReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.ExportInventoryReportTypeDetailedValues}`, inventoryReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportInventoryReportTypeSummaryValues(inventoryReportFilterModel: InventoryReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.ExportInventoryReportTypeSummaryValues}`, inventoryReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportInventoryReportTypeQuantities(inventoryReportFilterModel: InventoryReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.ExportInventoryReportTypeQuantities}`, inventoryReportFilterModel, {
      responseType: 'blob',
    });
  }

  inventoryReportBranchAverageCost(inventoryReportFilterModel: InventoryReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.InventoryReportBranchAverageCost}`, inventoryReportFilterModel);
  }

  inventoryReportEntryShop(inventoryReportFilterModel: InventoryReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.EntryShop}`,
      inventoryReportFilterModel);
  }

  inventoryReportKardexArticle(inventoryReportFilterModel: InventoryReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.KardexArticle}`,
      inventoryReportFilterModel);
  }

  inventoryReportOutputShop(inventoryReportFilterModel: InventoryReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.OutputShop}`,
      inventoryReportFilterModel);
  }

  inventoryReportStockMax(inventoryReportFilterModel: InventoryReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.StockMax}`,
      inventoryReportFilterModel);
  }

  inventoryReportStockMin(inventoryReportFilterModel: InventoryReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.StockMin}`,
      inventoryReportFilterModel);
  }

  inventoryReportSummaryInventoryMovements(inventoryReportFilterModel: InventoryReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.SummaryInventoryMovements}`,
      inventoryReportFilterModel);
  }

  inventoryReportTypeDetailedValues(inventoryReportFilterModel: InventoryReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.TypeDetailedValues}`,
      inventoryReportFilterModel);
  }

  inventoryReportTypeSummaryValues(inventoryReportFilterModel: InventoryReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.TypeSummaryValues}`,
      inventoryReportFilterModel);
  }

  inventoryReportTypeQuantities(inventoryReportFilterModel: InventoryReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryReport.TypeQuantities}`,
      inventoryReportFilterModel);
  }
}
